/* eslint-disable */
import trash from '../../images/icons/trash.svg';
import React, { useEffect, useMemo, useState } from 'react';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import { Field } from 'formik';
import { IoMdArrowDropdown } from "react-icons/io";
import getPpeKit from '../ppe/queries/getPpeKit';
import { TextField } from '@material-ui/core';
import showAlert from '../../utils/alert';

const PPEExpenseFieldForm = ({ id, setFieldValue, expenseCategoryList, index, crew, values, errors, touched,restoredPpeCategoryDetails,isCrewPage }) => {
  const [ppeListFinal, setppeListFinal] = useState([]);
  const [show, setShow] = useState(false);
  const oldCrew = useMemo(() => crew?.crewCode, []);
  const [columns, setColumns] = useState([]);

  const {mutate: getPpeKitList, data: ppeList} = getPpeKit();

  useEffect(() => {
    touched?.purchaseOrderCrew?.forEach((item, id) => {
    if(index === id){
    if(item?.ppeDeliveryRemarks || item?.ppeCategoryDetails?.length > 0) {
      setShow(true);
    }
  }
  })
}, [touched]);

  useEffect(() => {
      if (crew?.crewCode && crew?.expenseLineItemId,crew?.plannedVesselId) {
        getPpeKitList(crew);
      } 
      if(oldCrew !== crew?.crewCode) {
        setppeListFinal('');
      }
    }, [crew?.crewCode, crew?.expenseLineItemId,crew?.plannedVesselId]);

  useEffect(() => {
    if(!ppeList)
      {
        setFieldValue(`purchaseOrderCrew[${index}].ppeCategoryDetails`, []);
         return
      }
    if(oldCrew !== crew?.crewCode) {
      if (crew?.expenseLineItemId && ppeList?.status === 204) {
        setFieldValue(`purchaseOrderCrew[${index}].ppeDeliveryRemarks`, '');
        showAlert('Component mapping is not available for the specified Gender,Rank and Vessel', 'error');
        return
      }
    }
    if(restoredPpeCategoryDetails?.restoredPpeDetails?.length>0)
      {
        const dataNew = ppeList?.data?.ppeKitItems?.map((item) => ({
          componentName: item?.componentName,
          componentMasterId: item?.ppeComponentMasterId,
          componentId: item?.componentId,
          MasterId: ppeList?.data?.id,
          measurement: item?.measurement?.[0] || '',
          quantity: item?.quantity,
          isAdhoc: false,
          unitPrice:item?.unitPrice,
          unitPriceUsd:item?.unitPriceUsd,
          totalPrice: values?.currencyId === 1 ? item?.quantity * item?.unitPrice : item?.quantity * item?.unitPriceUsd
        }));
        if(restoredPpeCategoryDetails?.plannedVesselId == crew.plannedVesselId) {
         setppeListFinal(restoredPpeCategoryDetails?.restoredPpeDetails);
      } else {
        setFieldValue(`purchaseOrderCrew[${index}].ppeDeliveryRemarks`, '');
      }
      }

    else {
    if (crew?.ppeCategoryDetails?.length > 0) {  
      setppeListFinal(crew?.ppeCategoryDetails);
    } else {
      const ppeListFinal = ppeList?.data?.ppeKitItems?.map((item) => ({
        componentName: item?.componentName,
        componentMasterId: item?.ppeComponentMasterId,
        componentId: item?.componentId,
        MasterId: ppeList?.data?.id,
        measurement: item?.measurement?.[0] || '',
        quantity: item?.quantity,
        unitPrice:item?.unitPrice,
        unitPriceUsd:item?.unitPriceUsd,
        totalPrice: values?.currencyId === 1 ? item?.quantity * item?.unitPrice : item?.quantity * item?.unitPriceUsd
      }));
      if(values?.currencyId === 1) {
        setColumns(['Item', 'Size', 'Quantity', 'Unit Price(INR)', 'Total Price(INR)'])
        const amount = ppeListFinal?.reduce((acc, item) => acc + item?.quantity * item?.unitPrice, 0).toFixed(2);
        setFieldValue(`purchaseOrderCrew[${index}].amount`, Number(amount).toFixed(2)); 
        } else {
        setColumns(['Item', 'Size', 'Quantity', 'Unit Price(USD)', 'Total Price(USD)'])
          const amount = ppeListFinal?.reduce((acc, item) => acc + item?.quantity * item?.unitPriceUsd, 0).toFixed(2);
        setFieldValue(`purchaseOrderCrew[${index}].amount`, Number(amount).toFixed(2));    
        }
    }
  }
  }, [ppeList]);

  useEffect(() => {
    setFieldValue(`purchaseOrderCrew[${index}].ppeCategoryDetails`, ppeListFinal);
    if(values?.currencyId === 1) {
      setColumns(['Item', 'Size', 'Quantity', 'Unit Price(INR)', 'Total Price(INR)'])
      } else {
      setColumns(['Item', 'Size', 'Quantity', 'Unit Price(USD)', 'Total Price(USD)'])
      }
    if(crew?.expenseLineItemId && crew?.crewCode) {
      if (ppeListFinal.length > 0) {
      if(values?.currencyId === 1) {
      const amount = ppeListFinal?.reduce((acc, item) => acc + item?.quantity * item?.unitPrice, 0).toFixed(2);
      setFieldValue(`purchaseOrderCrew[${index}].amount`, Number(amount).toFixed(2)); 
      } else {
        const amount = values?.purchaseOrderCrew[0]?.ppeCategoryDetails?.reduce((acc, item) => acc + item?.quantity * item?.unitPriceUsd, 0).toFixed(2);
      setFieldValue(`purchaseOrderCrew[${index}].amount`, Number(amount).toFixed(2));    
      }
    } else {
      setFieldValue(`purchaseOrderCrew[${index}].amount`, '');
    }
    }
  }, [ppeListFinal, crew?.expenseLineItemId, values?.currencyId]);

  const category = expenseCategoryList?.find(({ expenseCategoryID }) => expenseCategoryID === id);

  const hanldeDelete = (item) => () => {
    let newPPEList=  values?.purchaseOrderCrew[0]?.ppeCategoryDetails?.filter((item) => !item?.isAdhoc).filter((i,idx) => item.componentName !== i.componentName);
    let newPPEListNonAdhoc=  values?.purchaseOrderCrew[0]?.ppeCategoryDetails?.filter((item) => item?.isAdhoc);
 
     setppeListFinal([...newPPEList, ...newPPEListNonAdhoc]);
   };

  return (
    <>
      {((!isCrewPage || crew?.crewCode) && crew?.expenseLineItemId) && (
      <div className="capitalize pt-6 font-extrabold text-base">
        <div className="cursor-pointer flex justify-between bg-white-dark p-2 text-sm" style={{ color: '#333869' }} onClick={() => setShow(!show)}>
          {category?.categoryName} - Add More details
                   <span
                      className={`rotatable ${show ? 'expanded' : 'collapsed'}`}
                    >
                      <IoMdArrowDropdown size={'25px'} color=''/>
                    </span>
        </div>
        <hr />
      </div>
      )}
    {((!isCrewPage || crew?.crewCode) && crew?.expenseLineItemId && show) && (
        <>
          <div className="flex-col justify-start items-start">
            <div className="required-field">
            <Field
              name={`purchaseOrderCrew[${index}].ppeDeliveryRemarks`}
              component={InputFieldComponent}
              className="w-full pt-3 text-base mb-4 "
              type="text"
              id="number"
              rounded
              label="Delivery Remarks"
              autoComplete="off"
              disabled={
                crew?.isShortClosed
                  || crew?.invoiceStatus?.toLowerCase().includes('payment')
                  || crew?.invoiceStatus?.toLowerCase().includes('voucher')
                  || crew?.invoiceStatus?.toLowerCase().includes('transferred')}
              multiline
            />
            {errors?.purchaseOrderCrew?.[index]?.ppeDeliveryRemarks && touched?.purchaseOrderCrew?.[index]?.ppeDeliveryRemarks && (
              <div className="text-red-500 text-xs">{errors?.purchaseOrderCrew?.[index]?.ppeDeliveryRemarks}</div>
            )}
            </div>
          </div>
          {values?.purchaseOrderCrew[0]?.ppeCategoryDetails?.length > 0 &&  values?.purchaseOrderCrew[0]?.ppeCategoryDetails
            ?.filter((item) => !item?.isAdhoc).length > 0 && (
            <table className="w-full ppe-table-rebuild">
            <thead>
              <tr>
                {columns.map((item) => (
                  <th key={item} className="font-bold capitalize">{item}</th>
                ))}
                <th></th>
              </tr>
            </thead>
            <tbody>
            {values?.purchaseOrderCrew[0]?.ppeCategoryDetails?.length > 0 && values?.purchaseOrderCrew[0]?.ppeCategoryDetails
            ?.filter((item) => !item?.isAdhoc)
            ?.map((item) => (
                <tr key={item?.componentName}>
                  <td>
                    <label title={item?.componentName}>{item?.componentName}</label>
                  </td>
                  {crew?.isShortClosed
                    || crew?.invoiceStatus?.toLowerCase().includes('payment')
                    || crew?.invoiceStatus?.toLowerCase().includes('voucher')
                    || crew?.invoiceStatus?.toLowerCase().includes('transferred') ? (
                      <>
                        <td>
                          <label>{item?.measurement}</label>
                        </td>
                        <td>
                          <label>{item?.quantity}</label>
                        </td>
                      </>
                    ) : (
                      <>
                        <td>
                          {item?.measurement || values?.purchaseOrderCrew[0]?.ppeCategoryDetails?.find((i) => i?.componentName === item?.componentName)?.measurement?.length > 0 ? (
                            <select
                              value={item?.measurement}
                              onChange={(e) => {
                                const newPPEList = values?.purchaseOrderCrew[0]?.ppeCategoryDetails?.map((i) => {
                                  if (i?.componentName === item?.componentName) {
                                    return { ...i, measurement: e.target.value };
                                  }
                                  return i;
                                });
                                setppeListFinal(newPPEList);
                              }}
                              className="w-full border-none rounded-md "
                            >
                              {ppeList?.data?.ppeKitItems?.find((i) => i?.componentName === item?.componentName)?.measurement?.map((i) => (
                                <option key={i} value={i}>{i}</option>
                              ))}
                              {ppeList?.data?.ppeKitItems?.find((i) => i?.componentName === item?.componentName)?.measurement?.includes(item?.measurement) ? null : (
                                <option value={item?.measurement}>{item?.measurement}</option>
                              )}
                            </select>
                          ) : null}
                        </td>
                        <td>
                          <TextField
                            type="number"
                            value={item?.quantity}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                              const eToNumber = e.target.value === '' ? '' : Math.floor(Number(e.target.value));
                                const price = values?.currencyId === 1 ? item?.unitPrice : item?.unitPriceUsd;
                                const newPPEList = values?.purchaseOrderCrew[0]?.ppeCategoryDetails?.map((i) => {
                                  if (i?.componentName === item?.componentName) {
                                    return { ...i, quantity: eToNumber, totalPrice: eToNumber * price };
                                  }
                                  return i;
                                });

                                setppeListFinal(newPPEList);

                            }}
                            className="w-full border-none rounded-md"
                            inputProps={{
                              min: 1
                            }}
                            style={{ backgroundColor: 'white' }}
                          />
                          {errors?.purchaseOrderCrew?.[index]?.ppeCategoryDetails?.[ppeListFinal?.findIndex((i) => i?.componentName === item?.componentName)]?.quantity && touched?.purchaseOrderCrew?.[index]?.ppeCategoryDetails?.[ppeListFinal?.findIndex((i) => i?.componentName === item?.componentName)]?.quantity && (
                            <div className="text-red-500 text-xs">{errors?.purchaseOrderCrew?.[index]?.ppeCategoryDetails?.[ppeListFinal?.findIndex((i) => i?.componentName === item?.componentName)]?.quantity}</div>
                          )}
                        </td>
                      </>
                    )}
                  <td>

                      {values?.currencyId === 1 ? 
                        <label title={Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPrice)}>
                          {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPrice)}
                        </label>
                        :
                        <label title={Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPriceUsd)}>
                          {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPriceUsd)}
                        </label>
                      }
                  </td>
                  <td>
                    <label title={(item?.quantity * (values?.currencyId === 1 ? item?.unitPrice : item?.unitPriceUsd)).toFixed(2)}>
                    {(item?.quantity * (values?.currencyId === 1 ? item?.unitPrice : item?.unitPriceUsd)).toFixed(2)}
                    </label>
                  </td>
                  <td className="ppe-table-action">
                    <button type="button" onClick={hanldeDelete(item)} hidden={
                      crew?.isShortClosed
                      || crew?.invoiceStatus?.toLowerCase().includes('payment')
                      || crew?.invoiceStatus?.toLowerCase().includes('voucher')
                      || crew?.invoiceStatus?.toLowerCase().includes('transferred')}>
                      <img src={trash} alt="DeleteIcon" title="Delete" className="action-icon w-6" />
                    </button>
                  </td>
                </tr>
              ))}
              { values?.purchaseOrderCrew[0]?.ppeCategoryDetails?.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-left">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
          )}
        </>
      )}
    </>
  );
};

export default PPEExpenseFieldForm;
